<template>
    <span
        class="ds-icon"
        :class="[
            !isSizeSet && `ds-icon--${swapBreakpoint.toString()}`,
            { 'ds-icon--thin': isThin },
            { 'ds-icon--regular': isRegular },
        ]"
    >
        <svg v-if="isSizeSet" :width="width" :height="height" :viewBox="getViewBox(width, height)">
            <use :xlink:href="getHref(name)" />
        </svg>
        <template v-else>
            <svg
                :width="iconSize.thin"
                :height="iconSize.thin"
                :viewBox="getViewBox(iconSize.thin, iconSize.thin)"
                class="ds-icon__thin"
            >
                <use :xlink:href="getHref(resolvedThinIconName)" />
            </svg>
            <svg
                :width="iconSize.regular"
                :height="iconSize.regular"
                :viewBox="getViewBox(iconSize.regular, iconSize.regular)"
                class="ds-icon__regular"
            >
                <use :xlink:href="getHref(name)" />
            </svg>
        </template>
    </span>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { ResponsiveUtils } from "@sazka/utils/responsive-utils";
import type { SvgIcons } from "./types";
import { iconNames } from "../typography/storiesIconName";

const props = withDefaults(
    defineProps<{
        width?: number;
        height?: number;
        name: SvgIcons;
        isInStorybook?: boolean;
        swapBreakpoint?: keyof Omit<typeof ResponsiveUtils.breakpoints, "xs">;
    }>(),
    {
        isInStorybook: false,
        swapBreakpoint: "sm2",
    }
);

const iconSize = {
    thin: 16,
    regular: 24,
};

const isSizeSet = computed((): boolean => !!props.width && !!props.height);

const isThin = computed((): boolean => props.width === iconSize.thin && props.height === iconSize.thin);

const isRegular = computed((): boolean => props.width === iconSize.regular && props.height === iconSize.regular);

const getViewBox = (width: number, height: number): string => `0 0 ${height} ${width}`;

const getHref = (iconName: string): string =>
    props.isInStorybook
        ? `/images/svg-icons/${iconName}.svg#${iconName}`
        : `/frontend/img/svg-icons/${iconName}.svg#${iconName}`;

const resolvedThinIconName = computed(() => {
    const thinIconName = `${props.name}-thin`;

    return iconNames.includes(thinIconName as SvgIcons) ? thinIconName : props.name;
});
</script>
